import { useState, useEffect } from 'react';

export const Status = Object.freeze({
  idle: 'idle',
  loading: 'loading',
  ready: 'ready',
  error: 'error',
});

const useScript = (src, htmlDocument = document) => {
  const [status, setStatus] = useState(src ? Status.loading : Status.idle);

  useEffect(() => {
    if (!src) {
      setStatus(Status.idle);
      return;
    }
    let script = htmlDocument.querySelector(`script[src="${src}"]`);
    if (!script) {
      script = htmlDocument.createElement('script');
      script.src = src;
      script.setAttribute('data-cb-site', window._env_.REACT_APP_CHARGEBEE_SITE);
      script.setAttribute('data-cb-ga-enabled', 'true');
      script.async = true;
      script.setAttribute('data-status', Status.loading);
      htmlDocument.body.appendChild(script);
      const setAttributeFromEvent = (event) => {
        script.setAttribute('data-status', event.type === 'load' ? Status.ready : Status.error);
      };
      script.addEventListener('load', setAttributeFromEvent);
      script.addEventListener('error', setAttributeFromEvent);
    } else {
      setStatus(Status.ready);
    }
    const setStateFromEvent = (event) => {
      setStatus(event.type === 'load' ? Status.ready : Status.error);
    };
    script.addEventListener('load', setStateFromEvent);
    script.addEventListener('error', setStateFromEvent);
    return () => {
      if (script) {
        script.removeEventListener('load', setStateFromEvent);
        script.removeEventListener('error', setStateFromEvent);
      }
    };
  }, [htmlDocument, src]);
  return { status };
};

export default useScript;
